<p-table
	#dt
	styleClass="p-datatable-responsive-demo"
	[value]="serviceLines"
	[loading]="!serviceLines"
	[globalFilterFields]="app.keys(serviceLines)"
	[scrollable]="true"
	[rows]="100"
	scrollHeight="700px"
>
	<ng-template pTemplate="caption">
		<div class="table-header d-flex">
			<div class="flex-grow-1">
				<span class="p-float-label p-input-icon-left m-2 w-100">
					<i class="pi pi-search"></i>
					<input
						pInputText
						class="w-100"
						id="globalSearch"
						name="globalSearch"
						style="width: 100%"
						type="text"
						(input)="dt.filterGlobal($event.target.value, 'contains')"
					/>
					<label for="globalSearch">Search...</label>
				</span>
			</div>
		</div>
	</ng-template>
	<ng-template pTemplate="header">
		<tr>
			<th pSortableColumn="lineDescription">
				Service
				<p-sortIcon field="lineDescription"></p-sortIcon>
			</th>
			<th pSortableColumn="quantity">
				Quantity
				<p-sortIcon field="quantity"></p-sortIcon>
			</th>
			<th pSortableColumn="price">
				Amount
				<p-sortIcon field="price"></p-sortIcon>
			</th>
			<th colspan="2" pSortableColumn="nextBillingDate">
				Frequency
				<p-sortIcon field="nextBillingDate"></p-sortIcon>
			</th>
		</tr>
	</ng-template>
	<ng-template let-rec pTemplate="body">
		<tr>
			<td>
				{{ rec.lineDescription }}
			</td>
			<td>
				{{ rec.quantity }}
			</td>
			<td>
				{{ rec.price | currency }}
			</td>
			<td class="d-flex flex-column">
				<div>
					{{ rec.billingFrequency }}
				</div>

				<div>next: {{ app.moment(rec.nextBillingDate).format("l") }}</div>
			</td>
			<td class="d-flex flex-column">
				<div>
					Auto Bill Pay
					<fa-icon [icon]="['far', 'check']" *ngIf="rec.autoBillPay" class="ms-1"></fa-icon>
					<fa-icon [icon]="['far', 'times']" *ngIf="!rec.autoBillPay" class="ms-1"></fa-icon>
				</div>

				<div *ngIf="rec.autoBillPay">
					{{ rec.autoBillPayPaymentMedium }}
				</div>
			</td>
		</tr>
	</ng-template>
</p-table>
<div class="d-flex">
	<div class="ms-auto p-text-italic descriptionText">service totals do not include tax or applicable fees</div>
</div>
